/**
 * Grabs all the style numbers from product trays on help page
 * @param state current redux state
 * @returns Array of style numbers
 */
export function helpStyleFetcher(state) {
    return _.get(state, 'help.productTrayStyleNumbers', []);
}
